export default "__VITE_ASSET__CZfAFPAD__"